module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.9e8940bc.mp3";